export default __webpack_public_path__ + "media/09bd1a87dfcdc53b759023330bf4923d1e177fa919b9bd0ba8251a890c89c64c.svg";